import crystall71 from "../../../media/ruko/rukol7/crystall71.png";
import crystall72 from "../../../media/ruko/rukol7/crystall72.png";
import crystall73 from "../../../media/ruko/rukol7/crystall73.png";
import crystall74 from "../../../media/ruko/rukol7/crystall74.png";
import crystall75 from "../../../media/ruko/rukol7/crystall75.png";
import crystall76 from "../../../media/ruko/rukol7/crystall76.png";
import crystall77 from "../../../media/ruko/rukol7/crystall77.png";
import crystall78 from "../../../media/ruko/rukol7/crystall78.png";

const crystall5images = [
  crystall71,
  crystall72,
  crystall73,
  crystall74,
  crystall75,
  crystall76,
  crystall77,
  crystall78,
];

export default crystall5images;
